import React from 'react'

export default function Loading() {
  return (
    <div class="bubble-loader">
    <div class="bubble"></div>
    <div class="bubble"></div>
    <div class="bubble"></div>
  </div>
    )
}
